export default __webpack_public_path__ + "static/media/corporate_banner.e0b677fe.jpg";